import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TabsviewComponent } from './tabsview.component';
import { TabsRoutingModule } from './tabs-routing.module';

import { CatalogueModule } from './../../component/catalogue/catalogue.module';
import { DemoModule } from './../../component/demo/demo.module';
import { CodeModule } from './../../component/code/code.module';

import {TabViewModule} from "../../component/ing/tabview/tabview";
import {TableModule} from "../../component/ing/table/table";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TabsRoutingModule,
    CatalogueModule,
    DemoModule,
    CodeModule,
    TabViewModule,
    TableModule
  ],
  declarations: [TabsviewComponent]
})
export class TabsviewDemoModule { }



// WEBPACK FOOTER //
// ./src/app/view/tabsview/tabsviewDemo.module.ts